import { render, staticRenderFns } from "./Monitorv2.vue?vue&type=template&id=b8da646c"
import script from "./Monitorv2.vue?vue&type=script&lang=js"
export * from "./Monitorv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports